// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/pencil.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/pencil'

import { Icon, type IconComponentProps } from '../icon'

export const PencilIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
